<template>
  <button
    @click.prevent="handleClick"
    class="cb-button cb-button--blue"
    :class="{
      className,
      'cb-button--loading': loading,
      'cb-button--padding-left': paddingLeft,
    }"
    :type="type"
    :disabled="disabled || loading"
  >
    <div class="cb-button__spinner">
      <transition name="fade">
        <cb-spinner v-if="loading" size="small"></cb-spinner>
      </transition>
    </div>
    <span><slot></slot></span>
  </button>
</template>

<script>
import { mapState } from 'vuex';
import Spinner from './Spinner.vue';

export default {
  computed: {
    ...mapState({
      isModalOpen: (state) => state.modal.isOpen,
    }),
  },
  props: {
    className: {
      type: String,
    },
    type: {
      type: String,
    },
    paddingLeft: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
  components: {
    cbSpinner: Spinner,
  },
};
</script>

<style lang="scss" scoped>
.cb-button {
  position: relative;

  &__spinner {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
  }

  &--loading {
    @include desktop {
      &.cb-button--padding-left {
        padding-left: 50px;
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
